import Swiper from 'swiper/bundle';

export default function () {
    // Alleen een slider starten als er ook slides zijn (bij alleen een video ontbreekt .swiper-wrapper)
    if (document.querySelector('.home-banner-swiper .swiper-wrapper') === null) {
        return;
    }

    const swiper = new Swiper('.home-banner-swiper', {
        loop: true,
        effect: "fade",
        speed: 1000,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
    });
}
